import { render, staticRenderFns } from "./Pembahasan.vue?vue&type=template&id=2379f077&"
import script from "./Pembahasan.vue?vue&type=script&lang=js&"
export * from "./Pembahasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports